// The two legal documents of this product on the official site (zh + en; English governs the terms). The App Store
// listing's custom EULA and the Play listing point to the same terms page (Owner decision list 2026-10-19 items 5 / 6).
export const PRIVACY_POLICY_URL = 'https://nezha2capital.com/privacy-home-inspector';
export const TERMS_OF_SERVICE_URL = 'https://nezha2capital.com/terms-home-inspector';
